// components/SessionWarningModal.jsx
import React from "react";
import { Modal, Button } from "antd";

const SessionWarningModal = ({ open, onExtend, onLogout }) => {
  return (
    <Modal
      open={open}
      title="Sitzung läuft bald ab"
      closable={false}
      footer={[
        <Button key="extend" type="primary" onClick={onExtend}>
          Verlängern
        </Button>,
        <Button key="logout" danger onClick={onLogout}>
          Abmelden
        </Button>,
      ]}
    >
      <p>Ihre Sitzung läuft in 60 Sekunden ab. Möchten Sie die Sitzung verlängern?</p>
    </Modal>
  );
};

export default SessionWarningModal;
